<script setup lang="ts">
  import Tooltip from './Tooltip.vue';

  defineProps<{
    name: string;
    active: boolean;
  }>();
</script>

<template>
  <Tooltip
    v-if="!active"
    content="Este colaborador está inativo"
  >
    <span class="text-red-16">{{ name }}</span>
  </Tooltip>
  <span v-else>{{ name }}</span>
</template>
